exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer[data-v-07700ed4]{cursor:pointer}.close-tag[data-v-07700ed4]{border-radius:50px;background-color:red;padding:1px 3px;margin-left:10px;position:relative;display:none}.close-tag[data-v-07700ed4]:hover{font-size:15px}.badge-pill:hover .close-tag[data-v-07700ed4]{display:block}", ""]);

// exports
